import { render, staticRenderFns } from "./PxRadiocheck.vue?vue&type=template&id=315b7fe0&scoped=true&"
import script from "./PxRadiocheck.vue?vue&type=script&lang=js&"
export * from "./PxRadiocheck.vue?vue&type=script&lang=js&"
import style0 from "./PxRadiocheck.vue?vue&type=style&index=0&id=315b7fe0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315b7fe0",
  null
  
)

export default component.exports